import { React, useRef } from 'react'
import ReactToPrint from "react-to-print";
import { saveAs } from "file-saver";
import { fetchGallery } from '../../features/gallerySlice/gallerySlice';


const NoticeView = ({ noticeId }) => {

    console.log("noticeId", noticeId)

    const imageRef = useRef();
    const url = { noticeId }
    const downloadImage = (url) => {
        fetch(url, {
            mode: 'no-cors',
        })
            .then(response => response.blob())
            .then(blob => {
                let blobUrl = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.download = url.replace(/^.*[\\\/]/, '');
                a.href = blobUrl;
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
    }

    return (
        <div
            className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
            id="noticeImage"
            tabIndex={-1}
            aria-labelledby="exampleModalScrollableLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-scrollable pointer-events-none relative w-auto">
                <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between rounded-t-md border-b border-gray-200 p-4">
                        <h5
                            className="text-primary-red text-center m-auto text-xl font-semibold leading-normal"
                            id="exampleModalScrollableLabel"
                        >
                            {noticeId.title}
                        </h5>
                        <button
                            type="button"
                            className="h-6 w-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="0 0 1024 1024"
                            >
                                <path
                                    fill="currentColor"
                                    d="m563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8L295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512L196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1l216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
                                />
                            </svg>
                        </button>
                    </div>
                    <div className="modal-body relative p-4">
                        <img
                            ref={imageRef}
                            src={noticeId.image}
                            className=" w-100 m-auto object-fill"
                            alt=""
                        />
                        <div className='text-primary-blue text-center '>

                            {noticeId.description}

                        </div>
                    </div>
                    <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end rounded-b-md border-t border-gray-200 p-4">
                        <div className="flex gap-3">
                            <button

                                onClick={() => { downloadImage(noticeId.image) }}


                                className="!bg-primary-blue font-Berkshire inline-block rounded px-6 py-2.5 text-lg font-semibold leading-tight text-white shadow-md"
                            >
                                Download
                            </button>

                            <ReactToPrint
                                trigger={() => (
                                    <button
                                        type="button"
                                        className="font-Berkshire inline-block rounded !bg-green-700 px-6 py-2.5 text-lg font-semibold leading-tight text-white"
                                    >
                                        Print
                                    </button>
                                )}
                                content={() => imageRef.current}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NoticeView